import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

const styles = theme => ({
  listItem: {
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: 0,
    '& + $listItem': {
      paddingTop: 15,
    },
  },
});

const InventoryTableRowHCPCCodes = (props) => {
  const HCPCCodes = props['HCPC Codes']
    .reduce((accumulator, currentValue) =>
      [
        ...accumulator,
        currentValue.map(item => item['HCPC S Code']).join(' or '),
      ],
    [],
    );
  return (
    <List disablePadding>
      {HCPCCodes.map((item, index) => (
        <ListItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${item}-${index}`}
          className={props.classes.listItem}
        >
          {item}
        </ListItem>
      ))}
    </List>
  );
};

InventoryTableRowHCPCCodes.propTypes = {
  'HCPC Codes': PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape({
      'HCPC S Code': PropTypes.string,
      ID: PropTypes.number,
    })),
  ).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(InventoryTableRowHCPCCodes);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryTable/InventoryTableRowHCPCCodes.js